export function getAuthHeaders() {
    return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt')}`
        }
    };
}
export function getAuthFormHeaders() {
    return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };
}
